
export enum BurnDirection {
    Down,
    Up
}